/**
 * OrbDocTutorialsBeginnerTaskManagerARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerTaskManagerARDocScreen
 */

import { useOrbDocTutorialsBeginnerTaskManagerARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerARDocScreenLogic';
import type { OrbDocTutorialsBeginnerTaskManagerARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerTaskManagerARDocView as OrbDocTutorialsBeginnerTaskManagerARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsBeginnerTaskManagerARDocBodyView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerARDocBodyView';
import { OrbDocTutorialsBeginnerTaskManagerARDocFooterView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerARDocFooterView';
import { OrbDocTutorialsBeginnerTaskManagerARDocHeaderView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerTaskManagerARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsBeginnerTaskManagerARDocScreenConfig>;
}

export function OrbDocTutorialsBeginnerTaskManagerARDocScreenView({ config: propsConfig }: OrbDocTutorialsBeginnerTaskManagerARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerTaskManagerARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerTaskManagerARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerTaskManagerAR" trait="OrbDocTutorialsBeginnerTaskManagerARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsBeginnerTaskManagerARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsBeginnerTaskManagerARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerTaskManagerARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerTaskManagerARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerARDocScreenView;
